<template>
    <div class="area-card">
        <div class="internal-header">
            <h2 class="title">Quem pode duplicar negócios?</h2>
            <span class="desc"
            >Defina os grupos de usuários autorizados a duplicar negócios e personalize o limite máximo por cliente.</span
            >
        </div>
        <div class="table">
            <ui-table
                :columns="tableColumns"
                :data="tableData"
                :loading="loading"
                :select-column-menu="false"
                :last-col-fixed="false"
                :line-white="true"
                not-found-icon="fa fa-file-contract"
                not-found-text="Não foram encontrados grupos de usuários para duplicação de negócios."
                name="duplicate-deals"
                tr-component="business/general-config/duplicate-deal/table-line" 
            />
        </div>
    </div>
</template>

<script>
import { uiTable } from '@/components/ui';

export default {
    name: 'configurations-business-general-duplicate-deal',

    components: {
        uiTable
    },

    props: {
        loading: {
            type: Boolean,
            required: true,
            default: true
        },
        tableData: {
            type: Array,
            required: true,
            default: () => [] 
        }
    },

    data() {
        return {
            tableColumns: [
                {
                    title: 'Grupos de Usuários',
                    size: '390'
                },
                {
                    title: 'Duplicar'
                },

                {
                    title: 'Limite por Cliente',
                    size: '124'
                }
            ],
            
        }
    },

    computed: {
    },

    methods: {
        
    },
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>